module.exports = __webpack_public_path__ + "static/media/available-building-black.3eed8d9c.svg";